import { gql } from "@apollo/client";

const SYNC_ORDER = gql`
  mutation {
    syncOrder {
      data
      status
      error
    }
  }
`;

export default SYNC_ORDER;
